<template lang='pug'>
  i.svg-icon.svg-icon-tips
    svg(
      :fill='color'
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(d='M49.7,0.7c0.4,0,0.8,0,1.2,0c0.2,0.1,0.3,0.2,0.5,0.2c3.9,0.5,7.7,4,7.4,8.7c0,0.6,0,1.2,0,1.8c0.4,0.1,0.8,0.2,1.1,0.3 c13.6,3.8,24.7,15.4,24.3,31.9c-0.2,7.6,0,15.3,0,22.9c0,0.5,0.1,1.3,0.5,1.6c3.2,3.1,6.4,6.1,9.7,9.1c0,2,0,4,0,6 c-0.6,0-1.2,0.1-1.8,0.1c-28.2,0-56.4,0-84.6,0c-0.6,0-1.1,0.1-1.7,0.1c0-2.2,0-4.3,0-6.5c0.3-0.2,0.6-0.3,0.8-0.5 c2.9-2.7,5.7-5.4,8.6-8c0.6-0.5,0.8-1.1,0.8-1.9c0-8.3-0.1-16.6,0-24.8c0-2.2,0.3-4.5,0.8-6.6c3.1-12,11-19.4,22.6-23.2 c1.8-0.6,1.8-0.6,1.9-2.5c0.1-4.2,2.6-7.4,6.7-8.4C48.8,0.9,49.2,0.8,49.7,0.7z M28.4,71.9c14.6,0,29,0,43.6,0c0-0.5,0-0.9,0-1.4 c0-9.5,0-19,0-28.5c0-3.4-0.9-6.6-2.6-9.5c-4.9-8.5-15.3-12.6-25.2-9.9c-8.3,2.2-16,9.5-15.8,20.8c0.2,9,0,17.9,0,26.9 C28.4,70.7,28.4,71.2,28.4,71.9z')
      
      path(d='M48.7,97.7c-1.3-0.5-2.7-0.8-4-1.5c-3.8-1.9-6-6.1-5.5-10c7.3,0,14.6,0,22,0c0.3,3.4-0.9,6.2-3.3,8.5 c-1.5,1.4-3.3,2.3-5.4,2.7c-0.3,0.1-0.5,0.2-0.7,0.3C50.8,97.7,49.8,97.7,48.7,97.7z')
      
      path(d='M49.4,52c-4.2,0-8.3,0-12.6,0c6.3-8.7,12.5-17.2,18.7-25.7c0.1,0,0.2,0.1,0.3,0.1c-2,5.4-3.9,10.7-5.9,16.3 c4.2,0,8.2,0,12.6,0C56,51.6,49.8,60.1,43.6,68.6c-0.1,0-0.2-0.1-0.2-0.1C45.4,63.1,47.3,57.7,49.4,52z')

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>